// extracted by mini-css-extract-plugin
export var cloudServices = "Cloud-module--cloud-services--b100a";
export var service = "Cloud-module--service--6d062";
export var subtitle = "Cloud-module--subtitle--d47ae";